/*
 * The organization pages as the v3 mockup draws them: a toolbar over a bordered table
 * (`.card.table-wrap` + `.table`), person cells with an avatar, outline team badges, team cards and
 * the readonly link fields of an issued invitation.
 */
.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.spacer {
  flex: 1;
}

.meta {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.scroll {
  overflow-x: auto;
}

.table {
  inline-size: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--surface-raised);
  font-size: var(--font-size-13);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  text-align: start;
  vertical-align: middle;
}

.table thead th {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}

.table tbody tr:last-child td {
  border-block-end: 0;
}

.table tbody tr:hover {
  background-color: var(--surface-sunken);
}

.number {
  text-align: end;
  font-variant-numeric: tabular-nums;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-1);
  white-space: nowrap;
}

.person {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.personText {
  display: flex;
  flex-direction: column;
}

.strong {
  color: var(--text);
  font-weight: var(--font-weight-semibold);
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.badgeLink {
  text-decoration: none;
}

.badgeLink:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.notice {
  margin: 0;
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-sunken);
  color: var(--text);
  font-size: var(--font-size-13);
}

.problem {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.status {
  margin: 0;
  color: var(--text);
  font-size: var(--font-size-13);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.two {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-3);
}

.linkField {
  display: flex;
  gap: var(--space-2);
}

.linkField > :first-child {
  flex: 1;
  min-inline-size: 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--space-3);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-raised);
  color: var(--text);
  text-decoration: none;
}

.card:hover {
  border-color: var(--border-control);
}

.card:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.avatars {
  display: flex;
  gap: var(--space-1);
}

.section {
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background-color: var(--surface-raised);
}

.sectionHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3);
  border-block-end: 1px solid var(--border);
}

.sectionTitle {
  margin: 0;
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-semibold);
}

.addRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3);
  border-block-start: 1px solid var(--border);
}

.label {
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
